<script setup>
const isEmbedded = ref(false)

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search)
  isEmbedded.value = urlParams.get('embedded') === 'true'
})
</script>

<template>
  <div :class="{ embedded: isEmbedded }">
    <NuxtPage />
  </div>
</template>
